export default "__VITE_ASSET__775b21fe__"